import { useEffect, useState } from "react";

interface MobileTakeoverCarouselProps {
  urls: string[];
}

const ROTATE_INTERVAL_MS = 5000;

export function MobileTakeoverCarousel({ urls }: MobileTakeoverCarouselProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (urls.length <= 1) return;
    const id = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % urls.length);
    }, ROTATE_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [urls.length]);

  useEffect(() => {
    if (urls.length === 0) return;
    setActiveIndex((prev) => (prev >= urls.length ? 0 : prev));
  }, [urls.length]);

  if (urls.length === 0) {
    return (
      <div
        aria-hidden="true"
        className="aspect-square w-full bg-[var(--bg-field)]"
      />
    );
  }

  const activeUrl = urls[activeIndex] ?? urls[0];

  return (
    <div className="relative w-full">
      <img
        src={activeUrl}
        alt="Created in IQ Design"
        className="aspect-square w-full object-cover"
      />
      <span className="absolute right-3 top-3 rounded-full bg-black/55 px-3 py-1 text-xs font-medium text-[var(--text-primary)] backdrop-blur-sm">
        Created in IQ Design
      </span>
      <div className="pointer-events-none absolute inset-x-0 bottom-3 flex justify-center gap-2">
        {urls.map((url, index) => (
          <span
            key={url}
            data-testid="carousel-dot"
            data-active={index === activeIndex}
            className={`h-1.5 w-1.5 rounded-full bg-white transition-opacity ${
              index === activeIndex ? "opacity-100" : "opacity-40"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
